
import FligthBookingMain from "../../components/flight-booking-report/FligthBookingMain"

export const FligthBookingReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <FligthBookingMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}